import {Injectable} from '@angular/core';
import {AlertController, LoadingController, ModalController, Platform} from "@ionic/angular";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {DomSanitizer} from "@angular/platform-browser";

import { Geolocation, PermissionStatus } from '@capacitor/geolocation';
import {environment} from "@environments/environment";

import {StorageService} from "@services/storage/storage.service";
import {UserService} from "@services/user/user.service";

import {appRoutingEnum} from "@enums/appRoutingEnum";

import {Device} from "@capacitor/device";
import {BehaviorSubject} from "rxjs";
import {HttpService} from "@services/http/http.service";
import {UiHelperService} from "@services/ui-helper/ui-helper.service";
//import {AuthService} from "@services/auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  get pageName(): any {
    return this._pageName;
  }

  set pageName(value: any) {
    this.pageName$.next(value);
    this._pageName = value;
  }

  public response: any;
  public back: any = false;
  public data: any = {current:{app:'',username:''}};


  public _pageName: any;
  public pageName$: BehaviorSubject<any | null>;
  public loading: any;
  public resultsPerPage: any = 20;
  // public signupData: { username: any, password: any };
  public appVersion: any = 206;
  public myPhotos: any;
  public isScroll: boolean = false;
  public footerShow: any = false;
  //public pageName:any = 'home';
  // public isBanner: any = false;
  public deviceInfo: any = {model:''};
  public token:any = '';

  constructor(
    public storage: StorageService,
    public uiHelper: UiHelperService,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public sanitizer: DomSanitizer,
    public user: UserService,
    public modalCtrl: ModalController,
    public plt: Platform,
    public http: HttpService,
    //public auth: AuthService
  ) {
    this.pageName$ = new BehaviorSubject(null);
    if(this.plt.is('hybrid')){
      this.getDeviceInfo().then();
    }
  }

  checkParams(params:any){
    if(typeof params.token != 'undefined' && params.token != '' && this.token != params.token) {
      //logout
      // this.storage.remove('user_id').then();
      // this.storage.remove('user_photo').then();
      //
      // auth.logout();
      // this.data['current'] = {};
      // this.storage.remove('userData').then();
      // this.http.setOneTimeHeader('','','');
      this.token = params.token;
      //this.uiHelper.keyboard?.hide().then();
      let myHeaders = new HttpHeaders();
      myHeaders = myHeaders.append('Content-type', 'application/json');
      myHeaders = myHeaders.append('Accept', '*/*');
      myHeaders = myHeaders.append("Authorization", "Basic " + btoa(encodeURIComponent(123) + '=:=' + encodeURIComponent('dfg')));
      myHeaders = myHeaders.append('Token', this.token);
      //myHeaders = myHeaders.append("Base", btoa(encodeURIComponent('empty') + '523' + encodeURIComponent('none')));
      return this.http.post(this.http.url + '/user/login/', {},{
          headers: myHeaders,
          observe: 'body'
        }).subscribe((data: any) => {
          console.log(data);
          if (data && typeof data.bash != 'undefined') {
            if (data.app == 'login') {
              this.http.setOneTimeHeader(data.username, data.password, data.bash);
              this.user.storage.setItem('userData', data).then();
              // if (this.pageName != appRoutingEnum.HOME) {
              //   router.navigate([appRoutingEnum.HOME]);
              // }
            }
          }
          // console.log(data);
        });
      // this.http.post(this.http.url + '/user/login/',
      //   {}, {
      //   headers: myHeaders,
      //   observe: 'body'
      // }).subscribe((data: any) => {
      //   console.log(data);
      //   if (data && typeof data.bash != 'undefined') {
      //     this.http.setOneTimeHeader(data.username, data.password, data.bash);
      //     this.user.storage.setItem('userData', data).then();
      //     if (data.app == 'login') {
      //       if (this.pageName != appRoutingEnum.HOME) {
      //         router.navigate([appRoutingEnum.HOME]);
      //       }
      //     }
      //   }
      //   // console.log(data);
      // }, error => {
      //   console.log(error);
      //   console.log(error.error.error);
      // });
    }else{
      return false;
    }
  }

  async getDeviceInfo(){
    this.deviceInfo = await Device.getInfo();
    console.log(this.deviceInfo);
    if(!this.deviceInfo || typeof this.deviceInfo.model == 'undefined'){
      this.deviceInfo = {model:''};
    }
  }


  /**
   * Sends the Devices push token to the server
   * @param {string}idPhone - the token to renderImagesToSendAsHtml
   * @type {{idPhone: string}=> void}
   */
  sendPhoneId(idPhone: string) {
    //if (this.user.username && this.user.password && idPhone) {
    console.log('push device token' + idPhone);
    this.storage.getItem('deviceToken').then((deviceToken: any) => {
      idPhone = (deviceToken && idPhone === '') ? deviceToken : idPhone;
      const data: any = JSON.stringify({deviceId: idPhone});
      console.log(data);
      if(!this.plt.is('mobileweb') && !this.plt.is('desktop')){
        console.log(this.deviceInfo);
        const os = this.deviceInfo.platform === 'ios' ? 'iOS' : this.deviceInfo.platform;
        this.http.post(this.http.url + '/user/deviceId/OS:' + os, data).subscribe((res: any) => {
        }, error => {
        });
      } else {
        this.http.post(this.http.url + '/user/deviceId/OS:browser', data).subscribe((res: any) => {
        }, error => {
        });
      }
    });
  //}
  }

  /**
   *  renderImagesToSendAsHtml user's Current Location
   */
  async setLocation() {
    // Geolocation.getCurrentPosition().then((pos) => {
    //   const params = JSON.stringify({
    //     latitude: '' + pos.coords.latitude + '',
    //     longitude: '' + pos.coords.longitude + ''
    //   });
      this.checkPermissions();
      const coordinates = await Geolocation.getCurrentPosition();

      console.log('Current position:', coordinates);
    const params = {
        latitude: coordinates.coords.latitude,
        longitude: coordinates.coords.longitude
      };
    // this.storage.getItem('userData').then((data:any) => {
    //   if(data){

        this.http.post(this.http.url + '/locations', params).subscribe();
    //   }
    // });
      // if (typeof this.user.getUserData() == 'object') {
      //   this.http.post(this.http.url + '/locations', params).subscribe();
      // }
    // });
  }

  async checkPermissions() {
    const status: PermissionStatus = await Geolocation.checkPermissions();
    console.log(status);
    // if (status.state !== 'granted') {
    //   await Geolocation.requestPermissions();
    // }
  }

  async sendLocation(){
    this.checkPermissions();
    const coordinates = await Geolocation.getCurrentPosition();

    console.log('Current position:', coordinates);
    const params = {
      latitude: coordinates.coords.latitude,
      longitude: coordinates.coords.longitude
    };
    this.http.post(this.http.url + '/locations', params).subscribe(data => {
    });
  }

  /**
   * Searches an array of objects, and returns the index of the
   * object whose value matches the value received for a specified key,
   * or null if none could be found.
   * @param array - The array of objects to search.
   * @param key - The key to search in.
   * @param value - The value to search for.
   * @returns index - The index of the object that meets criteria, or null if none could be found.
   */
  findIndexByKeyValue(array: object[], key: string, value:any): any {
    const index:any = array.findIndex((elem: any) => elem[key] == value);
    return index === -1 ? null : index;
  }
}


